<template>
    <div class="scanner-page-container">
        <ScannerComponent></ScannerComponent>
    </div>
</template>

<script>
import ScannerComponent from '@/components/Picking/Scanner.vue';

export default {
    components: {
        ScannerComponent
    }
}
</script>

<style scoped>
.scanner-page-container {
    padding-left: 60px;
    padding-right: 60px;
}

@media (max-width: 768px) {
    .scanner-page-container {
        padding-left: 10px;
        padding-right: 10px;
    }
}
</style>